import { render } from "./ListOfProperties.vue?vue&type=template&id=31e41863&scoped=true&ts=true"
import script from "./ListOfProperties.ts?vue&type=script&lang=ts"
export * from "./ListOfProperties.ts?vue&type=script&lang=ts"

import "./ListOfProperties.vue?vue&type=style&index=0&id=31e41863&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e41863"]])

export default __exports__